import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function InnerCircle() {
  const comparison = [{
    sit: 'No sabés qué suplemento comprar en Argentina',
    sin: 'Buscás en Google y tirás plata',
    con: 'Directorio actualizado con links verificados y precios del mes'
  }, {
    sit: 'Aplicás el sistema pero no mejora',
    sin: 'Seguís probando al azar',
    con: 'Análisis de correlaciones personales + identificación de tu patrón dominante'
  }, {
    sit: 'Tenés dudas específicas de tu caso',
    sin: 'Nadie te responde',
    con: 'Contacto directo vía mail — te respondemos en menos de 48hs'
  }, {
    sit: 'Viajás y se rompe tu ritmo',
    sin: 'Perdés todo el progreso',
    con: 'Protocolo Anti-Jet Lag + protocolo de viaje dentro de Argentina'
  }, {
    sit: 'Vas a un asado o evento social',
    sin: 'Todo el sistema se desordena',
    con: 'Sistema Social Power — disfrutás sin destruir el sueño'
  }, {
    sit: 'Querés rendir mejor también de día',
    sin: 'El sistema termina al despertar',
    con: 'Biohacking de alto rendimiento diurno — la regla del 90-90-90'
  }, {
    sit: 'Querés estar en contacto con Close The Gap',
    sin: 'No sabés dónde encontrarnos',
    con: 'Seguinos en nuestras redes sociales y formá parte de nuestra comunidad activa'
  }];
  const includes = ['Sistema de Personalización por Cronotipo (León / Oso / Lobo / Delfín)', 'Directorio Vivo de Suplementación Argentina (actualización mensual)', 'Protocolo de Biohacking de Rendimiento Diurno', 'Guía de Análisis Clínicos — Los 6 Marcadores del Sueño Imposible', 'Protocolo Anti-Jet Lag para viajes desde Argentina', 'Sistema Social Power para asados y eventos', 'Soporte directo vía mail — respondemos en menos de 48hs', 'Seguimiento en redes sociales con contenido exclusivo de la comunidad', 'Roadmap de Transformación 90 Días'];
  return <section className="py-24 relative bg-slate-900/40 border-y border-white/5" data-id="element-148">
      <div className="container mx-auto px-4" data-id="element-149">
        <div className="text-center mb-12" data-id="element-150">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-151">
            <span aria-hidden="true" data-id="element-152">🕊️</span> ¿QUÉ AGREGA EL SISTEMA DE
            IMPLEMENTACIÓN AVANZADO?
          </h2>
        </div>

        <div className="max-w-5xl mx-auto mb-20" data-id="element-153">
          <div className="md:hidden text-center text-sm text-slate-500 mb-4 flex items-center justify-center gap-2" data-id="element-154">
            ← Scroll to see full table →
          </div>
          <div className="overflow-x-auto hide-scrollbar rounded-2xl border border-white/10 bg-slate-800/20" data-id="element-155">
            <table className="w-full min-w-[800px] text-left border-collapse" data-id="element-156">
              <thead data-id="element-157">
                <tr className="border-b border-white/10 bg-slate-800/50" data-id="element-158">
                  <th className="p-5 font-semibold text-slate-300 w-1/3" data-id="element-159">
                    Situación real
                  </th>
                  <th className="p-5 font-semibold text-slate-400 w-1/3 flex items-center gap-2" data-id="element-160">
                    <XCircle size={18} className="text-red-400" data-id="element-161" /> Sin Sistema
                    Avanzado
                  </th>
                  <th className="p-5 font-semibold text-amber-400 w-1/3" data-id="element-162">
                    <div className="flex items-center gap-2" data-id="element-163">
                      <CheckCircle2 size={18} data-id="element-164" /> Con Sistema Avanzado
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5" data-id="element-165">
                {comparison.map((row, i) => <tr key={i} className="hover:bg-slate-800/30 transition-colors" data-id="element-166">
                    <td className="p-5 text-slate-300 text-sm" data-id="element-167">{row.sit}</td>
                    <td className="p-5 text-slate-400 text-sm" data-id="element-168">{row.sin}</td>
                    <td className="p-5 text-amber-100 text-sm font-medium bg-amber-900/10" data-id="element-169">
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="max-w-4xl mx-auto p-8 md:p-12 rounded-3xl bg-gradient-to-br from-slate-800/80 to-slate-900/80 border border-white/10 shadow-xl" data-id="element-170">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-171">
            <span aria-hidden="true" data-id="element-172">✅</span> EL SISTEMA DE IMPLEMENTACIÓN
            AVANZADO INCLUYE:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-173">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-start gap-3" data-id="element-174">
                <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 shrink-0" data-id="element-175" />
                <span className="text-slate-300 text-sm leading-relaxed" data-id="element-176">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}